import IPlayerData from '../../Player/IPlayerData';
import { getEndpointByLevelData, getLatestEndpointByDate } from '../../Player/DataRestoreHelper';
import { report } from '../../report';
import { fbPendingRequestCategorizer } from '../SDK/Drivers/FBHelpers';
import { Logger, LogThresholds } from '../Logger/Logger';
import { LogOrigin } from '../Logger/LogOrigin';
import { LogStyles } from '../Logger/LogStyles';

/**
 * if true, logs verbose info to console
 */
const DBG_SAVE_MODE: boolean = false;

export function getLatestData(dataBuffer: IPlayerData[]): IPlayerData | null {
    const higherProgressData = getEndpointByLevelData(dataBuffer);
    const newestData = getLatestEndpointByDate(dataBuffer);

    return higherProgressData || newestData || null;
}

export const saveHandlerLogger = {
    debugLog(val: string): void {
        if (DBG_SAVE_MODE) {
            Logger.log(val, LogOrigin.LOCAL_STORAGE_SAVER, LogStyles.DEFAULT, LogThresholds.HIGH);
        }
    },

    log(val: string): void {
        Logger.log(val, LogOrigin.LOCAL_STORAGE_SAVER, LogStyles.DEFAULT, LogThresholds.HIGH);
    },

    warn(val: string): void {
        Logger.log(val, LogOrigin.LOCAL_STORAGE_SAVER, LogStyles.WARNING);
    },

    error(val: Error): void {
        Logger.log(val, LogOrigin.LOCAL_STORAGE_SAVER, LogStyles.ERROR);
    },
};

export function handleSaverError(err: Error): void {
    report('Failed to save', {
        error: err,
        once: true,
        sampleRate: 0.1,
        categorizers: [fbPendingRequestCategorizer('save')],
    });
}
